import RichText from '@/components/utilities/RichText';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const H5 = ({ text, h5align }) => {
  let classNameAlign = 'text-left';
  if (h5align === 'center') {
    classNameAlign = 'text-center mx-auto';
  } else if (h5align === 'right') {
    classNameAlign = 'text-right';
  }

  return (
    <VisibleLoading delay={100}>
      {({ ref, className }) => (
        <h5 ref={ref} className={`xl:max-w-[820px] ${classNameAlign} ${className || ''}`.trim()}>
          <RichText>{text}</RichText>
        </h5>
      )}
    </VisibleLoading>
  );
};
export default H5;
